import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["showSection", "hideSection"];
  static values = { reveal: String };

  connect() {
    this.update();
  }

  update() {
    const checked = this.element.querySelector("input[type=radio]:checked");
    const revealed = checked?.value === this.revealValue;

    for (const section of this.showSectionTargets) {
      section.classList.toggle("hidden", !revealed);
    }
    for (const section of this.hideSectionTargets) {
      section.classList.toggle("hidden", revealed);
    }
  }
}
